import React from 'react';
import Typography from '@mui/material/Typography';

import Item from './Item';
import sharedAccountsApi from 'api/sharedAccountsApi';
import config from 'config';

class StartComponent extends React.Component {
  state = {
    currentState: "pending",
    heading: 'Loading, please wait.',
    message: ''
  };

  componentDidMount = async () => {
    const { user, bannerHandler } = this.props;
    const canView = user.CanView || user.CanSubmit || user.IsAdmin;

    sharedAccountsApi.getAdminMessage()
    .then(result => {
      if(result.Message) {
        bannerHandler(result.Message);
      }
    })
    .catch(error => {
      return;
    });

    if(canView) {
      await sharedAccountsApi.getUserInfo(user.UserID)
      .then(async userInfo => {
        
        await sharedAccountsApi.getCompetitors()
        .then(async competitors => {

          if(!userInfo.Dealer) {
            this.handleError("NoDealer");
          } else {
            this.handleSuccess(competitors, userInfo, user);
          }      

        });
      })
      .catch(error => {
        this.handleError(error);
      });

    } else {
      this.handleError("NoViewAccess");
    }
  }

  handleSuccess = (competitors, userInfo, user) => {
    const { userInfoHandler } = this.props;
    var displayPeriod = userInfo.DisplayPeriod;
    var nextPeriod = userInfo.NextPeriod;
    var heading = "Share of Accounts";
    var message = this.state.message;

    if(displayPeriod && displayPeriod.Quarter && displayPeriod.Year) {
      heading = "Share of Accounts - " + displayPeriod.Quarter + " " + displayPeriod.Year;
    }

    userInfoHandler(userInfo.IsDealerPrincipal, userInfo.IsShareofAccountApprover);

    this.setState({
      currentState: "start",
      heading: heading,
      message: message,
      displayPeriod: { IsEligible: userInfo.IsEligible, ...displayPeriod },
      nextPeriod: nextPeriod,
      user: { ContactID: userInfo.ContactID, IsDealerPrincipal: userInfo.IsDealerPrincipal, IsShareofAccountApprover: userInfo.IsShareofAccountApprover, ...user},
      dealer: userInfo.Dealer,
      competitors: competitors
    });

  }

  handleError = (error) => {
    var heading = "Error Occurred";
    var message = "Something went wrong. " + 
      "Please try again later or contact";
    var emailSubject = "Share of Accounts - Error";

    if(error === "NoDealer") {
      heading = "Error";
      message = "An error occurred while gathering required data to display your Share of Account information. " +
        "Please try again later or contact";
      emailSubject = "Share Of Accounts - Data Error";
    }

    if(error === "NoViewAccess") {
      heading = "Unauthorized";
      message = "You do not have access to this application with your currently logged in account. "+ 
        "If you require access to this application please contact";
      emailSubject = "Share Of Accounts - Access Error";
    }

    this.setState({
      currentState: "error",
      heading: heading,
      message: message,
      emailSubject: emailSubject
    });
  }

  handleNext = (isEligible) => {
    var message = isEligible ? 
      "Thank you for providing the requested information. We appreciate your partnership." : 
      "Thank you for providing the requested information. Please note these results were submitted after the scheduled time and are not eligible for funds.";

    this.setState({
      currentState: "thankyou",
      heading: "Share of Accounts",
      message: message
    });
  }

  renderEmailLink = (subject) => {
    subject = subject ? subject : "Share of Accounts Inquiry";
    return (
      <React.Fragment>
        &nbsp;
        <a href={'mailto:MktServ@honcompany.com?subject=' + subject}>
          MktServ@honcompany.com
        </a>
      </React.Fragment>
    );
  }

  render() {
    const { competitors, user, dealer, displayPeriod, nextPeriod,
      currentState, message, heading, emailSubject } = this.state;

    const quarter = displayPeriod && displayPeriod.Quarter;
    const year = displayPeriod && displayPeriod.Year;

    return (
      <React.Fragment>

        <Typography component="h1" variant="h4" align="center">
          { heading }
        </Typography>

        <br />  

        <Typography variant="subtitle1">
          { message }
          {currentState === "error" &&
            this.renderEmailLink(emailSubject)
          }
          {(currentState === "thankyou" || currentState === "error" ) &&
            <React.Fragment>
              <p> Click <a href={config.portalUrl || '#'}>here</a> to return to the HON Ready portal. </p>
              <p> <a href="/home">BACK</a> </p>
            </React.Fragment>
          }
        </Typography>

        {currentState === "start" && (user.CanView || user.CanSubmit || user.IsAdmin) && 
          <Item 
            handleNext={this.handleNext}
            competitors={competitors}
            displayPeriod = {displayPeriod}
            nextPeriod = {nextPeriod}
            user={user}
            dealer={dealer}
            quarter={quarter}
            year={year}
          />
        }

      </React.Fragment>
    );
  }
}

export default (StartComponent);
